<script lang="ts">
  import clsx from 'clsx';
  import { Cross } from '@athena-lib/Icons';
  import { Link } from '@athena-lib/Link';
  import { getCommonTranslations } from '@athena-lib/commonTranslationsContext';
  import ForwardCircle from '@athena-lib/Icons/ForwardCircle.svelte';
  import AccountCircle from '@athena-lib/Icons/AccountCircle.svelte';
  import { getLoginContext } from '@athena-lib/loginContext.svelte';
  import { focusTrap } from '@athena-lib/focusTrap.svelte';
  import type { DrawerMenuProps } from './types';

  const {
    mainMenuItems,
    secondaryMenuItems,
    tertiaryMenuItems,
    closeDrawer,
    signInLinkText,
    accountLinkText,
    reorderLinkText,
    reorderUrl,
    restoreFocus,
    onAccountClick,
  }: DrawerMenuProps = $props();

  const translations = getCommonTranslations();
  const { isLoggedIn } = $derived(getLoginContext());
  const accountText = $derived(isLoggedIn ? accountLinkText : signInLinkText);
</script>

<div use:focusTrap={restoreFocus}>
  <div class="-ml-4 -mt-4">
    <button type="button" onclick={closeDrawer} class="p-2" aria-label={translations.closeText}>
      <Cross sizeClass="w-6 h-6" />
    </button>
  </div>
  <nav aria-label={translations.drawerMenu}>
    <div class="flex justify-between border-b border-st-gray-700 py-4">
      <button
        type="button"
        onclick={onAccountClick}
        class="flex items-center gap-2 py-4"
        data-initialfocus
      >
        <span aria-hidden="true">
          <AccountCircle sizeClass="w-6 h-6" />
        </span>
        {accountText}
      </button>
      <Link href={reorderUrl} class="flex items-center gap-2 py-4">
        <span aria-hidden="true">
          <ForwardCircle sizeClass="w-6 h-6" />
        </span>
        {reorderLinkText}
      </Link>
    </div>
    {#each [mainMenuItems, secondaryMenuItems, tertiaryMenuItems] as mobileMenu}
      {#key mobileMenu}
        <ul class="border-b border-st-gray-700 py-8 last:border-0 last:pb-0">
          {#each mobileMenu as item (item.link?.href + item.text)}
            <li
              class={clsx(
                mobileMenu === mainMenuItems && 'text-3xl font-bold leading-loose',
                mobileMenu === secondaryMenuItems && 'font-bold leading-xloose',
                mobileMenu === tertiaryMenuItems && 'leading-xloose',
              )}
            >
              <Link {...item.link}>{item.text}</Link>
            </li>
          {/each}
        </ul>
      {/key}
    {/each}
  </nav>
</div>
